import { UserProfile } from "@/models/userProfile";
import { getUserProfile } from "@/services/userProfileService";
import { defineStore } from "pinia";
import { TrustGroup } from "@/models/trustGroup";
import { getTrustGroupOnSession } from "@/services/trustGroupService";

export interface IUserProfileState {
  userProfile: UserProfile;
  trustGroup: TrustGroup;
}

export const useUserProfileStore = defineStore("userProfileStore", {
  state: (): IUserProfileState => ({
    userProfile: new UserProfile(),
    trustGroup: new TrustGroup(),
  }),

  actions: {
    async setUserProfile(): Promise<void> {
      this.userProfile = await getUserProfile();
    },

    async setTrustGroup(): Promise<void> {
      this.trustGroup = await getTrustGroupOnSession();
    },
  },
});
